<template>
  <div
    class="is-clickable mt-5 py-5 pr-15"
    :class="{ 'selected-doc-tree': open }"
    @click="changeState"
  >
    <b-icon icon="file-document-outline" size="is-small" class="pl-10 pr-15" />
    <span class="is-unselectable">{{ docName.toUpperCase() }}</span>
  </div>
</template>

<script>
export default {
  name: "DocTree",
  model: {
    prop: "value",
    event: "update"
  },
  props: {
    docName: {
      type: String,
      default: () => ""
    },
    docId: {
      type: String,
      default: () => ""
    },
    value: {
      type: String,
      default: () => ""
    }
  },
  computed: {
    open: {
      get() {
        return this.docId === this.value;
      },
      set(value) {
        this.$emit("update", value);
      }
    }
  },
  methods: {
    changeState() {
      this.open = this.docId;
    }
  }
};
</script>
